import React, { useState, useEffect } from 'react';
import { apiClient } from '../../components/api/ApiClient';

const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ریال';
};

function SubscriptionHistory() {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);

    useEffect(() => {
        async function fetchHistory() {
            try {
                const response = await apiClient('/subscribe/api/history/');
                setHistory(response || []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }
        fetchHistory();
    }, []);

    const toggleRow = (index) => {
        if (expandedRow === index) {
            setExpandedRow(null);
        } else {
            setExpandedRow(index);
        }
    };

    if (loading) return <div className="col-xl-12"><div className="card stretch"><div className="card-body">در حال بارگذاری تاریخچه اشتراک...</div></div></div>;
    if (error) return <div className="col-xl-12"><div className="card stretch"><div className="card-body alert alert-danger">خطا در بارگذاری تاریخچه: {error}</div></div></div>;

    const renderStatus = (isActive) => {
        if (isActive) {
            return <div className="badge bg-soft-success text-success">فعال</div>;
        } else {
            return <div className="badge bg-soft-warning text-warning">منقضی شده</div>;
        }
    };

    const renderPaymentStatus = (isPaid) => {
        return isPaid ?
            <span className="badge bg-success">پرداخت شده</span> :
            <span className="badge bg-warning text-dark">در انتظار پرداخت</span>;
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card stretch">
                        <div className="card-header">
                            <h5 className="card-title">تاریخچه اشتراک</h5>
                        </div>
                        <div className="card-body custom-card-action p-0">
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">نام پلن</th>
                                            <th scope="col">قیمت پرداختی</th>
                                            <th scope="col">تاریخ شروع</th>
                                            <th scope="col">تاریخ پایان</th>
                                            <th scope="col">وضعیت</th>
                                            <th scope="col" className="text-end">عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {history.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted">تاریخچه اشتراکی یافت نشد.</td>
                                            </tr>
                                        ) : (
                                            history.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <tr
                                                        onClick={() => toggleRow(index)}
                                                        style={{ cursor: 'pointer', backgroundColor: expandedRow === index ? '#f8f9fa' : 'inherit' }}
                                                    >
                                                        <td><span className="fw-bold text-dark">{item.plan?.name || '-'}</span></td>
                                                        <td><span className="fw-bold text-dark">{formatPrice(item.price)}</span></td>
                                                        <td>{item.start_date || '-'}</td>
                                                        <td>{item.end_date || '-'}</td>
                                                        <td>{renderStatus(item.is_active)}</td>
                                                        <td>
                                                            <div className="d-flex justify-content-end align-items-center">
                                                                <span className="text-muted small me-2">
                                                                    {expandedRow === index ? 'بستن' : 'مشاهده اقساط'}
                                                                </span>
                                                                <a href="#" className="avatar-text avatar-md" onClick={(e) => { e.preventDefault(); toggleRow(index); }}>
                                                                    <i className={`feather-${expandedRow === index ? 'chevron-up' : 'chevron-down'}`}></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    {expandedRow === index && (
                                                        <tr>
                                                            <td colSpan="6" className="p-0">
                                                                <div className="bg-light p-3">
                                                                    <h6 className="mb-3">جدول اقساط</h6>
                                                                    {item.installments && item.installments.length > 0 ? (
                                                                        <div className="table-responsive bg-white rounded shadow-sm">
                                                                            <table className="table table-bordered mb-0">
                                                                                <thead className="table-primary">
                                                                                    <tr>
                                                                                        <th>#</th>
                                                                                        <th>تاریخ سررسید</th>
                                                                                        <th>تاریخ پرداخت</th>
                                                                                        <th>مبلغ (ریال)</th>
                                                                                        <th>وضعیت پرداخت</th>
                                                                                        <th>کد پیگیری تراکنش</th>
                                                                                        <th>شناسه پرداخت</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {item.installments.map((inst, i) => (
                                                                                        <tr key={inst.id || i}>
                                                                                            <td>{i + 1}</td>
                                                                                            <td>{inst.due_date}</td>
                                                                                            <td>{inst.paid_date || '-'}</td>
                                                                                            <td>{formatPrice(inst.amount)}</td>
                                                                                            <td>{renderPaymentStatus(inst.is_paid)}</td>
                                                                                            <td>{inst.payments?.[0]?.transaction_id || '-'}</td>
                                                                                            <td>{inst.payments?.[0]?.id || '-'}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="alert alert-info mb-0">
                                                                            قسطی برای نمایش وجود ندارد
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionHistory;